
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1345","height":"1345","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M414.993 414.952C661.475 168.442 975.209 30.365 1297.17.208c39.81-3.739 62.83 43.841 34.53 72.133L72.42 1331.8c-27.85 27.82-75.862 5.7-72.225-33.47C30.13 975.946 168.237 661.773 414.993 414.952z","fill":"#FFE300"}})])
          )
        }
      }
    